<template>
  <div class="p-d-flex p-jc-center p-ai-center login" style="height: 100%; direction: rtl;  ">

    <Card class="card-login" >
      <template #header>
        <img :src="imageUrl" :title="titleLoginPage"/>
      </template>
      <template class="" #title>

        ברוכים הבאים
      </template>
      <template #subtitle>
        {{ titleLoginPage }}
      </template>
      <template #content>
        <div class="p-fluid">
          <div class="p-p-1 p-field  ">
        <span class="p-float-label">
            <InputText autocomplete="username" id="id" type="text" v-model="id"/>
            <label for="id">תעודת זהות</label>
        </span>
          </div>
          <div class=" p-p-1 p-field ">
        <span class="p-float-label">
                        <Password id="password" v-model="password" :toggleMask="true" :feedback="false"/>

            <label for="password">סיסמה</label>
        </span>
          </div>
          <div class=" p-p-1 p-field ">
            <Button label="התחבר" @click="login"/>

          </div>

        </div>

      </template>
      <!--      <template #footer>-->

      <!--      </template>-->
    </Card>
  </div>
</template>

<script>
// import d from "../assets/"
import {mapActions, mapState} from "vuex";
import service from "../service/Service";
import axios from "axios";

export default {
  service: null,
  name: "login",
  components: {},
  mounted() {
    this.titleLogin = process.env.VUE_APP_TITLE
    this.service = new service();


  },

  methods: {
    ...mapActions(["setUser", "setPermissions", "setUserSettings"]),
    login() {
      if (true) {
        this.service
            .login({
              username: this.id,
              password: this.password,
            }, 'user')
            .then(() => {
              this.$router.push("/");

              this.service.getMe('user')
                  .then((data) => {
                    this.setUser(data.user);
                      console.log("data.permissions", data.permissions)

                      this.setPermissions(data.permissions);

                    this.service.getMySettings('user-settings')
                        .then((settings) => {
                          settings === "" ? this.setUserSettings({}) : this.setUserSettings(settings)
                        })
                  });
            })
            .catch(e => {
              this.openNotification(
                  "danger",
                  `קרתה תקלה בהתחברות`,
                  e
              );
            });
      }
    },
    openNotification(color, title, text, position = "right-left", duration = 3000) {
      this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
    },
  },
  created() {

  },
  data() {
    return {
      id: null,
      password: null,
    };
  },
  computed: {
    imageUrl() {
      return require(`${process.env.VUE_APP_IMAGE_LOGIN}`)
    },
    titleLoginPage() {
      return process.env.VUE_APP_TITLE
    },
    ...mapState(["intro", "user"]),
  },
};
</script>

<style scoped>
.layout {
  min-height: 50vh;
}

.card {
  border-radius: 8px;
  cursor: pointer;
}

.card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19) !important;
}

.container {
  /* margin-top: -70px; */
}

.login {
  background: var(--primary-color) !important;
}

@media screen and (min-width: 992px) {
  .card-login {
    width: 30vw !important;
  }
}
@media screen and (max-width: 992px) {
  .card-login {
    width: 35vw !important;
  }
}
@media screen and (max-width: 768px) {
  .card-login {
    width: 50vw !important;

  }
}
@media screen and (max-width: 576px) {
  .card-login {
    width: 70vw !important;
  }
}
</style>
